import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs";
import { TealiumUtagService } from "../../../../tealium/utag.service";
import { EventService } from "../../controller/event.service";
import { ConfigService } from "../../../../config.service";

@Component({
  selector: "app-event",
  templateUrl: "./event.component.html",
  styleUrls: [],
})
export class EventComponent implements OnInit, OnDestroy {
  openStepModal: boolean = false;

  sub: any = null;
  public config: any;
  
  constructor(
    public EventController: EventService,
    private route: ActivatedRoute,
    private tealium: TealiumUtagService,
    private configService: ConfigService,
    private renderer: Renderer2,
  ) {}
  ngOnInit() {

    this.sub = this.route.params.subscribe((data) => {
      this.EventController.event = null;
      this.EventController.getEventInformations(data.event).then(()=> {
        let typeEvent = this.EventController.event.type == "physical"
            ? "en_physique"
            : "en_ligne";
        this.tealium.view(
          "page_atelier",
          document.title,
          this.EventController.event.buSlug,
          typeEvent,
          this.EventController.event.trackingId
        );
      });
    });
  }
  
  
  // @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
  //   const crossEvents = document.getElementById("cross-events");
  //   const stickyButton = document.getElementById("sticky-button-register");
  //   if (crossEvents.getBoundingClientRect() !== null) {
  //     if (window.scrollY > crossEvents.getBoundingClientRect().top) {
  //       stickyButton.style.display = "none";
  //     }
  //     else {
  //       stickyButton.style.display = "block";
  //     }
  //   }
  // }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.overflowBody();
  }

  overflowBody() {
    if (window.matchMedia("(min-width: 768px)").matches) {
      document.getElementsByTagName("body")[0].style.overflow = "";
    }
  }

  openModalRegister() {
    this.EventController.dataForm.modalOpen = true;
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/event/event.component.ts